<template>
  <div>
    <b-modal
      ref="modal"
      class="modal-confirm"
      content-class="rounded-10 position-relative"
      hide-footer
      hide-header
      size="sm"
      :visible="!!isShow"
      :centered="true"
      no-close-on-backdrop
      no-close-on-esc
      no-enforce-focus
      @hide="close"
      @close="close"
    >
      <div class="modal-vip">
        <div class="header">
          <div class="title">{{ $t('VIP方案') }}</div>
          <div class="slider">
            <b-carousel v-model="slide" style="height: 100%" indicators>
              <b-carousel-slide
                v-for="carousel in carouselArr"
                :key="carousel.key"
              >
                <template #img>
                  <div
                    class="position-relative align-items-center justify-content-center"
                    style="width: 100%; height: 100%"
                  >
                    <div class="icon-wrapper">
                      <i class="icon" :class="carousel.icon"></i>
                    </div>
                    <div class="bottom-text text-center">
                      <div
                        class="caption font-weight-bold d-flex align-items-center justify-content-center"
                      >
                        {{ carousel.text }}
                      </div>
                      <div
                        class="carousel-content text-16 d-flex align-items-center justify-content-center"
                      >
                        {{ carousel.subText }}
                      </div>
                    </div>
                  </div>
                </template>
              </b-carousel-slide>
            </b-carousel>
          </div>
          <span class="btn-close icon-X" @click.prevent="close"></span>
        </div>
        <div class="content">
          <b-button
            class="button"
            variant="primary"
            size="md"
            @click="gotoGetVip"
          >
            {{ $t('前往購買') }}
          </b-button>
          <p
            class="button-text text-primary button mt-3 mb-0 cursor-pointer"
            @click="close('VipModal_CancelButton_Click')"
          >
            {{ $t('下次再說') }}
          </p>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {TYPES} from '@/constant/ModalVip';

export default {
  props: {
    value: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      slide: 0,
    };
  },
  computed: {
    ...mapGetters({
      user: 'user/userData',
      isLoading: 'env/isLoading',
      isShow: 'env/isShowVipModal',
    }),
    carouselArr() {
      return [
        {
          key: 'carousel1',
          icon: 'icon-Chart-line',
          text: this.$t('棋譜覆盤'),
          subText: this.$t('有效掌握對局表現'),
        },
        {
          key: 'carousel2',
          icon: 'icon-lightning',
          text: this.$t('無限體力'),
          subText: this.$t('棋力提升不需等待'),
        },
        {
          key: 'carousel3',
          icon: 'icon-File',
          text: this.$t('棋魂對決'),
          subText: this.$t('自由選擇角色挑戰'),
        },
        {
          key: 'carousel5',
          icon: 'icon-Camera',
          text: this.$t('{boardSize}路拍照數地', {boardSize: 19}),
          subText: this.$t('結果即刻呈現'),
        },
      ];
    },
    type() {
      if (TYPES[this.isShow]) return this.isShow;
      return TYPES.DEFAULT;
    },
    isIos() {
      return this.$store.getters['env/isIos'];
    },
    isAndroid() {
      return this.$store.getters['env/isAndroid'];
    },
  },
  watch: {
    type: {
      handler(newType) {
        this.setSlideByType(newType);
      },
      immediate: true,
    },
  },
  methods: {
    setSlideByType(type) {
      const typeToIndex = {
        [TYPES.REVIEW]: 0,
        [TYPES.ENERGY]: 1,
        [TYPES.NPC_GAME]: 2,
        [TYPES.LIVE]: 3,
        [TYPES.CAMERA_TO_SCORE_GAME]: 4,
      };
      this.slide = typeToIndex[type] ?? 0;
    },
    close(eventName) {
      if (eventName) this.trackEvent(eventName);
      this.$store.commit('env/setIsShowVipModal', false);
      this.$emit('input', false);
    },
    async trackEvent(eventName) {
      await this.$gaTrack(eventName);
    },
    gotoVipInfo() {
      this.close('VipModal_LearnMoreButton_Click');
      this.$router.replace({name: 'vip-training-plan'});
    },
    gotoGetVip() {
      this.close('VipModal_ShopNow_Click');
      if (this.isIos || this.isAndroid) return this.gotoVipInfo();
      return this.$openHomePage('/origin/#/shop/products/aiTutor-1');
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-vip {
  border-radius: 10px;
  overflow: hidden;
  width: 320px;
  height: 472px;
  text-align: center;
  .header {
    background: $secondary;
    padding: 16px 32px 26px;
    .title {
      font-size: 20px;
      font-weight: 700;
      line-height: 34px;
      color: $white;
    }
    .slider {
      margin: 16px 0;
      .carousel {
        padding: 32px;
        background: white;
        border-radius: 20px;
        .caption {
          margin: 8px 0;
          line-height: 44px;
          font-size: 28px;
        }
        .carousel-content {
          line-height: 28px;
        }
        .icon-wrapper {
          font-size: 70px;
          color: $primary;
        }
      }
      :deep(.carousel-indicators) {
        bottom: -16px !important;
        height: 10px;
        margin: 0;
        li {
          background-color: $white;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          opacity: 1;
          &.active {
            background-color: #303133;
          }
        }
      }
    }
  }
  i {
    font-size: 78px;
  }
  .content {
    padding: 24px 16px;
    color: $font-normal;
    background: $white;
    & > div {
      white-space: pre-line;
    }
    .button-text {
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
    }
  }
  .button {
    min-width: 240px;
    font-size: 20px;
    font-weight: 700;
    line-height: 34px; /* 170% */
  }
  .btn-close {
    cursor: pointer;
    position: absolute;
    font-size: 32px;
    top: 14px;
    right: 14px;
    color: white;
  }
}
.cursor-pointer.text-primary:hover {
  color: $hover-primary !important;
}
:deep().modal-body {
  padding: 0;
}
:deep().modal-content {
  width: 320px;
  margin: auto;
}
</style>
